import styled from "styled-components";
import FiSearch from "@assets/svg/FiSearch.svg?react";

// Interfaces for props
export interface IDirectionProps {
  $isRtl: boolean;
}

export interface ITabProps {
  $isActive: boolean;
}

// Styled components
export const Container = styled.div`
  width: 100%;
`;

export const TitleContainer = styled.div<IDirectionProps>`
  width: 582px;
  height: ${(props) => (props.$isRtl ? "74px" : "90px")};
  gap: 16px;
`;

export const MainTitle = styled.h1`
  font-weight: 700;
  font-size: 20px;
  color: #130080;
`;

export const SubTitle = styled.p`
  font-weight: 400;
  font-size: 16px;
  color: #adbac7;
`;

export const MainSection = styled.section`
min-height: 420px;
  margin-top: 40px;
  height: auto;
  padding-bottom: 40px;
  background-color: white;
  border-radius: 10px;
  gap: 24px;
  box-shadow: 0px 1px 2px 0px #1018280d;
  border: 1px solid #e3e8ef;
`;

export const TabsContainer = styled.div`
  margin-top: 26px;
  margin-right: 20px;
  display: flex;
  height: 36px;
  align-items: center;
  justify-content: flex-start;
`;

export const Tab = styled.div<ITabProps>`
  cursor: pointer;
  margin-left: 10px;
  background-color: ${(props) => (props.$isActive ? "#EEEBFF" : "transparent")};
  color: ${(props) => (props.$isActive ? "#364152" : "#8E98A1")};
  border-radius: 8px;
  padding: 8px 16px;
`;

export const SearchSection = styled.div<IDirectionProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-inline: 20px;
`;

export const TitleGroup = styled.span`
  display: flex;
  flex-direction: column;
  height: object-fit;
  margin-block: 24px;
  gap: 4px;
`;

export const SectionTitle = styled.h2`
  font-weight: 700;
  font-size: 18px;
  color: #121926;
`;

export const SectionSubtitle = styled.p`
  font-weight: 400;
  font-size: 14px;
  color: #475467;
`;

export const SearchWrapper = styled.span`
  position: relative;
`;

export const SearchInput = styled.input`
  width: 537px;
  height: 52px;
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  padding: 12px 16px;
  font-weight: 400;
  font-size: 16px;
`;

export const SearchIcon = styled(FiSearch)<IDirectionProps>`
  font-size: 25px;
  position: absolute;
  left: ${(props) => (props.$isRtl ? "16px" : "auto")};
  right: ${(props) => (!props.$isRtl ? "16px" : "auto")};
  top: 50%;
  transform: translateY(-50%);
`;

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-inline: 20px;
`;

export const CardWrapper = styled.span`
`;

export const NoResults = styled.div`
  grid-column: span 3;
  text-align: center;
  padding-block: 32px;
  color: #475467;
`;

export const IconWrapper = styled.div<IDirectionProps>`
  display: flex;
  flex-direction: ${(props) => (!props.$isRtl ? "row-reverse" : "row")};
  padding-inline: 24px;
`;
